"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadMoment = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _ = require("../..");

var _FullVideoWarning = require("../FullVideoWarning");

var _limiter = require("../../util/limiter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DownloadMoment = function DownloadMoment(props) {
  var _props$item$meta;

  var _useState = (0, _react.useState)("confirm"),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      downloadStatus = _useState4[0],
      setDownloadStatus = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      downloadStart = _useState6[0],
      setDownloadStart = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      downloadValue = _useState8[0],
      setDownloadValue = _useState8[1];

  var _useState9 = (0, _react.useState)(60),
      _useState10 = _slicedToArray(_useState9, 2),
      expectedTime = _useState10[0],
      setExpectedTime = _useState10[1];

  var gd = (0, _moment.default)(new Date());
  var downloadName = "Trace-Moment-".concat(gd.format("YYYYMMDD"), ".mp4");
  var isFullGame = props.item ? ((_props$item$meta = props.item.meta) === null || _props$item$meta === void 0 ? void 0 : _props$item$meta.type) === "FullGameVideo" : false;

  var processPressed = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var ds, start;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e) {
                e.preventDefault();
              }

              setStep("processing");
              _context.next = 4;
              return requestDownload(props.item);

            case 4:
              ds = _context.sent;
              setDownloadStatus(ds);

              if (ds.duration) {
                setExpectedTime(Math.round(ds.duration) * 5);
              }

              start = Date.now();
              downloadStart = start;
              setDownloadStart(start);
              setDownloadValue(0);

              if (ds && ds.ready) {
                setStep("ready");
              } else {
                setTimeout(function () {
                  checkStatus();
                  updateProgress();
                }, 500);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function processPressed(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var updateProgress = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var val;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              val = Date.now() - downloadStart;
              setDownloadValue(val);

              if (step !== "ready") {
                setTimeout(updateProgress, 123);
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateProgress() {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkStatus = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var ds;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return checkDownload(props.item);

            case 2:
              ds = _context3.sent;

              if (ds.ready) {
                setStep("ready");
                setDownloadStatus(ds);
              } else {
                setTimeout(checkStatus, 2000);
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function checkStatus() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var _props$item;

    if ((_props$item = props.item) !== null && _props$item !== void 0 && _props$item.game_clip_id && step === "confirm") {
      if (isFullGame) {
        var _props$item$dynamic, _props$item2, _props$item2$meta, _props$item2$meta$hom, _props$item3;

        downloadName = downloadName.replace("Moment", "FullGame");
        var fp = (_props$item$dynamic = props.item.dynamic) === null || _props$item$dynamic === void 0 ? void 0 : _props$item$dynamic.hls.split("/");
        var file = fp[0];
        file = file.replace("hls", "mp4");
        var teamName = (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : (_props$item2$meta = _props$item2.meta) === null || _props$item2$meta === void 0 ? void 0 : (_props$item2$meta$hom = _props$item2$meta.home_team) === null || _props$item2$meta$hom === void 0 ? void 0 : _props$item2$meta$hom.id;
        var url = "https://".concat(window.location.host, "/api/teams/").concat(teamName, "/games/").concat(teamName, "-").concat((_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.game_id, "/").concat(file);
        setStep("ready");
        setDownloadStatus({
          ready: true,
          moment_url: url
        });
      } else {
        processPressed();
        setStep("processing");
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_.StepController, {
    step: step
  }, /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "confirm"
  }, /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.Column, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    type: _.Label.Type.Heading4,
    marginBottom: "4"
  }, "TRACE_BOT is booting up")))), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "processing"
  }, /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    marginBottom: "4",
    content: "Preparing moment for download...",
    color: _.Color.Grey1,
    type: _.Label.Type.Body
  }), /*#__PURE__*/_react.default.createElement(_.ProgressBar, {
    total: expectedTime * 1000,
    value: downloadValue,
    marginBottom: "4",
    background: _.Color.Grey4
  }), props.showChildren && props.children)), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "ready"
  }, /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.Column, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true
  }, downloadName), props.expirationDays && /*#__PURE__*/_react.default.createElement(_FullVideoWarning.FullVideoWarning, {
    expirationDays: props.expirationDays
  }), iOS() && /*#__PURE__*/_react.default.createElement(_.Label, {
    background: _.Color.WarningTint2,
    borderColor: _.Color.Warning,
    borderRadius: "16px",
    borderWidth: "1px",
    padding: "4",
    center: true
  }, "Safari for iOS will download your video into the Files app.")), props.showChildren && props.children), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Button, {
    trk: "ShareDialog:Download Moment File:Pressed",
    content: "Download moment now",
    href: downloadStatus ? downloadStatus.moment_url : "#download",
    download: downloadName,
    onClick: function onClick(e) {
      return props.handleOnClickDownloadNow(downloadStatus);
    },
    primary: true
  }))), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "error"
  }, /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.Column, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true
  }, "Hmmm ... couldn't create that download. Please try again."))), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Button, {
    content: "Try Again",
    primary: true,
    onClick: function onClick(e) {
      setStep("confirm");
    }
  }))));
};

exports.DownloadMoment = DownloadMoment;

function iOS() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}

function requestDownload(moment) {
  return (0, _limiter.limiter)({
    name: "requestDownload",
    moment: moment
  }, function (success, failure) {
    return new Promise(function (resolve, reject) {
      var url = "https://lapi.traceup.com/exec-".concat(process.env.REACT_APP_TRACE_ENV, "/clip/download");
      fetch(url, {
        method: "POST",
        body: JSON.stringify(moment),
        mode: "cors"
      }).then(function (resp) {
        return resp.json();
      }).then(function (json) {
        var url = "";

        if (json && json.data && json.data.moment_url) {
          url = json.data.moment_url;
        }

        var data = {
          moment_url: url,
          ready: json.data.ready,
          duration: json.data.duration
        };
        success();
        resolve(data);
      }).catch(function (e) {
        failure();
        resolve(null);
      });
    });
  });
}

function checkDownload(moment) {
  return (0, _limiter.limiter)({
    name: "checkDownload",
    moment: moment
  }, function (success, failure) {
    return new Promise(function (resolve, reject) {
      var url = "https://lapi.traceup.com/exec-".concat(process.env.REACT_APP_TRACE_ENV, "/clip/download?game_clip_id=") + moment.game_clip_id;

      if (moment.parent_ref_id) {
        url += "&parent_ref_id=".concat(moment.parent_ref_id);
      }

      fetch(url, {
        method: "GET",
        mode: "cors"
      }).then(function (resp) {
        return resp.json();
      }).then(function (json) {
        var url = "";

        if (json && json.data && json.data.moment_url) {
          url = json.data.moment_url;
        }

        var data = {
          moment_url: url,
          ready: json.data.ready
        };
        success();
        resolve(data);
      }).catch(function (e) {
        failure();
        resolve(null);
      });
    });
  });
}